import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=a282a88e"
import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports